// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AnimationSpeedController from "./animation_speed_controller"
application.register("animation-speed", AnimationSpeedController)

import AppStoreCheckoutController from "./app_store_checkout_controller"
application.register("app-store-checkout", AppStoreCheckoutController)

import AppStoreLinkController from "./app_store_link_controller"
application.register("app-store-link", AppStoreLinkController)

import AppStoreReviewBannerController from "./app_store_review_banner_controller"
application.register("app-store-review-banner", AppStoreReviewBannerController)

import AppStoreSubscriptionController from "./app_store_subscription_controller"
application.register("app-store-subscription", AppStoreSubscriptionController)

import ArxivFunnelController from "./arxiv_funnel_controller"
application.register("arxiv-funnel", ArxivFunnelController)

import ArxivPreviewController from "./arxiv_preview_controller"
application.register("arxiv-preview", ArxivPreviewController)

import ArxivReferenceController from "./arxiv_reference_controller"
application.register("arxiv-reference", ArxivReferenceController)

import ArxivStatusController from "./arxiv_status_controller"
application.register("arxiv-status", ArxivStatusController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import Bridge__MenuController from "./bridge/menu_controller"
application.register("bridge--menu", Bridge__MenuController)

import Bridge__ThemedButtonController from "./bridge/themed_button_controller"
application.register("bridge--themed-button", Bridge__ThemedButtonController)

import BtnFeedbackController from "./btn_feedback_controller"
application.register("btn-feedback", BtnFeedbackController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CodeInputController from "./code_input_controller"
application.register("code-input", CodeInputController)

import CountdownButtonController from "./countdown_button_controller"
application.register("countdown-button", CountdownButtonController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HeroVideoController from "./hero_video_controller"
application.register("hero-video", HeroVideoController)

import KindleEmailController from "./kindle_email_controller"
application.register("kindle-email", KindleEmailController)

import KindleVerificationController from "./kindle_verification_controller"
application.register("kindle-verification", KindleVerificationController)

import OfflineCopyController from "./offline_copy_controller"
application.register("offline-copy", OfflineCopyController)

import OnboardingWizardController from "./onboarding_wizard_controller"
application.register("onboarding-wizard", OnboardingWizardController)

import OptionalFieldsController from "./optional_fields_controller"
application.register("optional-fields", OptionalFieldsController)

import OutboxController from "./outbox_controller"
application.register("outbox", OutboxController)

import OutboxSignOutController from "./outbox_sign_out_controller"
application.register("outbox-sign-out", OutboxSignOutController)

import PaddleCheckoutController from "./paddle_checkout_controller"
application.register("paddle-checkout", PaddleCheckoutController)

import PasteController from "./paste_controller"
application.register("paste", PasteController)

import PendingShareController from "./pending_share_controller"
application.register("pending-share", PendingShareController)

import ProgressDemoController from "./progress_demo_controller"
application.register("progress-demo", ProgressDemoController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TocController from "./toc_controller"
application.register("toc", TocController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import UploadFormController from "./upload_form_controller"
application.register("upload-form", UploadFormController)

import VersionBarController from "./version_bar_controller"
application.register("version-bar", VersionBarController)
